import React, { useState } from 'react'

export default function Input({ defaultText = '', ...props }) {
  const [text, setText] = useState(defaultText);

  return (
    <input {...props} type="text" onChange={(event) => setText(event.target.value)} value={text}/>
  )
}
